import React from "react";
import ChatRoom from "../ChatRoom";
import ChatInput from "../ChatInput";
import { IoIosArrowBack } from "react-icons/io";
import { useHistory } from "react-router-dom";
import {
  ButtonBack,
  ContainerCard,
  HeaderChat,
  ImageAvatar,
} from "./index.style";
import { IPaymentTracking } from "../../../interfaces/paymentTracking";

const ChatContent = (props: IPaymentTracking) => {
  const history = useHistory();

  return props ? (
    <ContainerCard>
      <HeaderChat>
        <ButtonBack>
          <IoIosArrowBack onClick={() => history.goBack()} />
        </ButtonBack>
        <ImageAvatar src={props.imageUrl} />
        {props.displayName}
        {props.status === 4 && " (ติดตามผลการรักษา)"}
      </HeaderChat>
      <ChatRoom {...props} />
      <ChatInput {...props} />
    </ContainerCard>
  ) : null;
};

export default ChatContent;
